<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [noSubmit]="true"
  [showCloseBtn]="false"
  [isShowModal]="false"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()"
  (valueChange)="onFormChange()">
  <ng-container class="content">
    <kgrid
      #grid
      [apiName]="apiName"
      [areaName]="areaName"
      [label]="label"
      [noToolBar]="true"
      [groupable]="true"
      [name]="apiName"
      [columns]="gridColumns"
      aggregatesColumnName="SumDebitInClosing,SumCreditInClosing,BeforSumDebit,BeforSumCredit,SumDebit,SumCredit,DebitRemain,CreditRemain"
      [hasRefresh]="false"
      [isEdit]="false"
      [isAdd]="false"
      [isDelete]="false"
      [paging]="false"
      [dataList]="entitys"
      [actions]="actions"
      [actionTregger]="onActionClick.bind(this)">
    </kgrid>
  </ng-container>
</dynamic-form>
